import { MutateFn } from '@diritto/common/base/mutateFunction';
import { ProfileBlockApi } from 'api/ApiHelper';
import { profileBlockQueryKey } from 'queries/profileBlock/queryKey';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useBlockProfileMutation = (profileId: number, callback: MutateFn) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: profileBlockQueryKey.profileBlock(profileId),
    mutationFn: () => ProfileBlockApi.blockProfile(profileId),
    onMutate: callback.onMutate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: profileBlockQueryKey.profileBlocks });
      callback.onSuccess?.();
    },
    onError: callback.onError,
  });
};
